<template>
	<div class="menu-container no-drag">
		<button type="button" class="btn-home" title="Home" @click="movePage(homeUrl)">
			<!-- 스마트 안심산모<span style="color:#F94848;"> 24</span> 모니터링 시스템 -->
			<div style="display:flex; align-items:center;">
				<img style="width: 354px;" src="@/assets/images/home/smart24_title.png" />
				<!-- 개발/운영 혼동방지용 텍스트 표시-->
				<span v-if="isDev" style="color:#ffcc00; font-size:22px; font-weight:bold; margin-left:12px;">(개발테스트용)</span>
			</div>
		</button>
		<ul class="menu-wrap" v-if="userName != ''">
			<li
				v-for="menu in menus"
				v-bind:key="menu.id"
				:title="menu.name"
				:style="menuName === menu.path ? 'background-color : #0176F9;' : ''"
				tabindex="0"
				@click.stop="movePage(menu.url)"
				@keyup.enter="movePage(menu.url)"
			>
			{{ menu.name }}
		</li>
		</ul>
		<div class="user-wrap" v-if="userName != ''">
			<div type="button" class="user-btn" title="myPage" @click.stop="doMypage()">
				<img style="width: 13px;" src="@/assets/images/left/menu_people.png" />
				{{userName}}
			</div>
			<button type="button" class="btn-logout" title="Logout" @click="doLogout()"></button>
		</div>
		<MyPage v-if="isMypage" />
	</div>
</template>

<script>
import EventBus from "@/script/EventBus.js";
import axios from "axios";
import MyPage from "@/components/mypage/MyPage.vue"

export default {
	name: "Menu",
	created() {
		this.logger.debug(this, "created()");
		this.meneSetting();

		// My Page 새 창 닫기
		EventBus.$on("mypage-cancel", () => {
			this.logger.debug(this, "[EventBus] mypage-cancel()");
			this.isMypage = false;
		});
	},
	beforeDestroy() {
		EventBus.$off('access-check');
	},
	props: {
		menuName: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			userName: sessionStorage.getItem('userName'),
			homeUrl: this.config.contextRoot + "/home",
			menus: [],
			isMypage: false,
		};
	},
	computed: {
		isDev() {
			return window.location.hostname === '192.168.11.46' || window.location.port === '2448' || window.location.port === '24';
		}
	},
	components:{
		MyPage
	},
	methods: {
		meneSetting(){
			if(sessionStorage.getItem('roleCd').indexOf('ROLE_ADMIN') >= 0){
				this.menus = [
					{
						id: 1,
						name: "수집데이터 기록",
						url: this.config.contextRoot + "/collectData",
						path: "/collectData"
					},
					{
						id: 2,
						name: "참여자 목록",
						url: this.config.contextRoot + "/participant",
						path: "/participant"
					},
					{
						id: 3,
						name: "알림 관리",
						url: this.config.contextRoot + "/setting",
						path: "/setting"
					},
					// {
					// 	id: 4,
					// 	name: "출산 후 관리",
					// 	url: this.config.contextRoot + "/care",
					// 	path: "/care"
					// },
					{
						id: 5,
						name: "코디네이터 목록",
						url: this.config.contextRoot + "/coordinator",
						path: "/coordinator"
					},
					{
						id: 6,
						name: "회원가입 관리",
						url: this.config.contextRoot + "/user",
						path: "/user"
					},
					{
						id: 7,
						name: "데이터 관리",
						url: this.config.contextRoot + "/emr_data_manage",
						path: "/emr_data_manage"
					},
				]
			}
			else if(sessionStorage.getItem('roleCd').indexOf('ROLE_MONITORING') >= 0){
				this.menus = [
					{
						id: 1,
						name: "수집데이터 기록",
						url: this.config.contextRoot + "/collectData",
						path: "/collectData"
					},
					{
						id: 2,
						name: "참여자 목록",
						url: this.config.contextRoot + "/participant",
						path: "/participant"
					},
					{
						id: 3,
						name: "알림 관리",
						url: this.config.contextRoot + "/setting",
						path: "/setting"
					},
					// {
					// 	id: 4,
					// 	name: "출산 후 관리",
					// 	url: this.config.contextRoot + "/care",
					// 	path: "/care"
					// },
					{
						id: 5,
						name: "코디네이터 목록",
						url: this.config.contextRoot + "/coordinator",
						path: "/coordinator"
					},
					{
						id: 7,
						name: "데이터 관리",
						url: this.config.contextRoot + "/emr_data_manage",
						path: "/emr_data_manage"
					},
				]
			}
			else if(sessionStorage.getItem('roleCd').indexOf('ROLE_COORDINATOR') >= 0){
				this.menus = [
					{
						id: 1,
						name: "수집데이터 기록",
						url: this.config.contextRoot + "/collectData",
						path: "/collectData"
					},
					{
						id: 2,
						name: "참여자 목록",
						url: this.config.contextRoot + "/participant",
						path: "/participant"
					},
					{
						id: 3,
						name: "알림 관리",
						url: this.config.contextRoot + "/setting",
						path: "/setting"
					},
					// {
					// 	id: 4,
					// 	name: "출산 후 관리",
					// 	url: this.config.contextRoot + "/care",
					// 	path: "/care"
					// },
					{
						id: 7,
						name: "데이터 관리",
						url: this.config.contextRoot + "/emr_data_manage",
						path: "/emr_data_manage"
					},
				]
			}
		},
		movePage(url) {
			this.logger.debug(this, "movePage(url)");
			if(url != this.config.contextRoot + "/setting/site"){
				this.$parent.menuNameSet(url);
				if (this.$route.path !== url) this.$router.push(url);
			}
			else{
				// let settingUrl = this.config.contextRoot + "/setting/" +
				if (this.$route.path !== url){
					axios
						.post(this.config.contextRoot + "/access/selectSettingAccessUrl.do", {userId : sessionStorage.getItem("userId")})
						.then((response) => {
							console.log(response.data.url);
							if(response.data.url == 'false'){
								this.$alert("You are not authorized.","Warning","warning");
							}
							else{
								// this.$alert(window.location.href ,"Warning","warning");
								let url = this.config.contextRoot + "/setting/" + this.getProjectName(response.data.url);
								if (this.$route.path !== url)
								{
									EventBus.$emit("project-loading", true);
									// this.$router.push(url);
									location.href = this.config.contextRoot + "/setting" + this.getProjectName(response.data.url);
								}
							}
						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						})
				}
			}
		},
		getProjectName(obj){
			let url = "";

			if(obj == 'ACCESS'){
				url = "/site";
			}
			else if(obj == 'EMR COLUMN MANAGE ACCESS'){
				url = "/emr_column_manage"
			}
			else if(obj == 'EMR DATA MANAGE ACCESS'){
				url = "/emr_data_manage"
			}
			return url;
		},
		doLogout() {
			this.logger.debug(this, "doLogout()");
			this.$confirm("로그아웃 하시겠습니까?", "Question", "question").then(() => {
				this.$Auth.logout(
					function(logoutResult) {
						if (logoutResult){
							this.userName = '';
							this.$router.push(this.config.contextRoot+"/");
						}
						else
							this.logger.debug(this, "logoutResult:" + logoutResult);
					}.bind(this)
				);
			});
		},
		doMypage() {
			this.logger.debug(this, "doMypage()");
			this.isMypage = true;
		},
	}
};
</script>

<style>
@import "../../assets/css/common/menu.css";
</style>
